import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { APPSETTING, APPUSER } from '../../main';

const KitstersAppLayout = () => {
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [activeTab, setActiveTab] = useState('Admin Appointments'); 
  
  const userDataString = localStorage.getItem(APPSETTING.appname + "user");
  const userData = userDataString ? JSON.parse(userDataString) : null;
  
  // Extract email for the avatar and menu
  const useremail = userData?.user?.email || "User";

  console.log("useremail " + useremail);

  const menuItems = [{"url":"dashboard","text":"Dashboard"},];
  
  const menuitemsadmin = [];

  const handleLogout = () => {
    localStorage.setItem(APPSETTING.appname + "user", null);
    navigate('/login');
  };

  return (
    <div className="dash-wrapper">
    
      <aside className="dash-sidebar">
        <div className="dash-sidebar-header">
          <span style={{ fontSize: '20px', cursor: 'pointer' }}>☰</span>
          <span>WhatsApp API</span>
        </div>

        <nav className="dash-nav">
          {window.APPUSER.user.usertype == "admin" && menuitemsadmin.map((item) => (
            <div 
              key={item}
              onClick={() => {setActiveTab(item);navigate("/" + item.url.toLowerCase());}}
              className={`nav-item ${activeTab === item ? 'active' : ''}`}
            >
              {item.text}
            </div>
          ))}
          {menuItems.map((item) => (
            <div 
              key={item}
              onClick={() => {setActiveTab(item);navigate("/" + item.url.toLowerCase());}}
              className={`nav-item ${activeTab === item ? 'active' : ''}`}
            >
              {item.text}
            </div>
          ))}
        </nav>
      </aside>

      <div className="dash-main">
        {/* Top Header */}
        <header className="dash-header">
          <div style={{ position: 'relative' }}>
            <div className="profile-circle" onClick={() => setShowProfileMenu(!showProfileMenu)}>
              {useremail[0].toUpperCase()}
            </div>

            {showProfileMenu && (
              <div style={{ 
                position: 'absolute', top: '50px', right: '0', 
                background: 'white', borderRadius: '8px', width: '220px', 
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100,
                border: '1px solid #e9edef', padding: '12px'
              }}>
                <div style={{ paddingBottom: '10px', borderBottom: '1px solid #eee', marginBottom: '10px' }}>
                  <div style={{ fontSize: '13px', fontWeight: '600', overflow: 'hidden', textOverflow: 'ellipsis' }}>{useremail}</div>
                </div>
                <button 
                  onClick={handleLogout}
                  className="btn-blue"
                  style={{ width: '100%', fontSize: '12px', padding: '8px' }}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        </header>

        {/* Main Content Area */}
        <div className="content-area">
            <Outlet />
        </div>
      </div>
    </div>
  );
};

export default KitstersAppLayout;